import MFHelpDeskRepository from "@adapters/features/HelpDesk/Repository/MFHelpDeskRepository";
export default (function (http) {
    return {
        mfHelpDesk: new MFHelpDeskRepository(http),
    };
});
